import { Component, input, InputSignal } from '@angular/core';

import { MDContentBoxComponent, MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-no-data-message',
	standalone: true,
	imports: [MDContentBoxComponent, MDIconComponent],
	templateUrl: './no-data-message.component.html',
	styleUrl: './no-data-message.component.scss'
})
export class NoDataMessageComponent {
	public icon: InputSignal<string | undefined> = input<string>();
	public iconUrl: InputSignal<string | undefined> = input<string>();
}
